import Assets from '../../Assets';

export default class HomeSlider extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            images: [
                {
                    url: Assets.home01,
                    text: 'Energy efficiency is our priority'
                },
                {
                    url: Assets.home02,
                    text: 'Cetetherm – the sustainable climate solution'
                },
                {
                    url: Assets.home03,
                    text: '+ 60 years of experience you can build on'
                }
            ],
            currentIndex: 0,
            translateValue: 0
        }

        this.timer = new Timer(() => {
            this.goToNextSlide();
        }, 5000);
    }

    goToPrevSlide = () => {
        if (this.state.currentIndex === 0)
            return;

        this.setState(prevState => ({
            currentIndex: prevState.currentIndex - 1,
        }), () => {
            this.timer.reset(5000);
        })
    }

    goToNextSlide = () => {
        if (this.state.currentIndex === this.state.images.length - 1) {
            return this.setState({
                currentIndex: 0
            })
        }

        this.setState(prevState => ({
            currentIndex: prevState.currentIndex + 1
        }), () => {
            this.timer.reset(5000);
        });
    }

    slideWidth = () => {
        return document.querySelector('.slide').clientWidth
    }

    render() {
        return (
            <div className="slider">
                <div className="slider-wrapper">
                    <div>
                        {this.state.images.map((image, i) => (
                            <Slide key={i} visible={i == this.state.currentIndex} image={image}/>
                        ))}
                    </div>
                    <div style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        height: '100%',
                        margin: '0 25px'
                    }}>
                        <LeftArrow goToPrevSlide={this.goToPrevSlide}/>
                        <RightArrow goToNextSlide={this.goToNextSlide}/>
                    </div>
                </div>
            </div>
        );
    }
}

const Slide = ({visible, image}) => {
    let styles = {
        background: `linear-gradient(
      rgba(0, 0, 0, 0.2), 
      rgba(0, 0, 0, 0.2)
      ), url(${image.url})`,
        backgroundSize: 'cover',
        backgroundPosition: '50% 60%',
        opacity: visible ? '1' : '0',
        transition: 'opacity 150ms'
    }

    return (
        <div className="slide" style={styles}>
            <h2>{image.text}</h2>
            <div></div>
        </div>
    )
}


const LeftArrow = (props) => {
    return (
        <div className="arrow left" onClick={props.goToPrevSlide}/>
    );
}


const RightArrow = (props) => {
    return (
        <div className="arrow right" onClick={props.goToNextSlide}/>
    );
}

function Timer(fn, t) {
    var timerObj = setInterval(fn, t);

    this.stop = function () {
        if (timerObj) {
            clearInterval(timerObj);
            timerObj = null;
        }
        return this;
    }

    // start timer using current settings (if it's not already running)
    this.start = function () {
        if (!timerObj) {
            this.stop();
            timerObj = setInterval(fn, t);
        }
        return this;
    }

    // start with new interval, stop current interval
    this.reset = function (newT) {
        t = newT;
        return this.stop().start();
    }
}